var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',[_c('div',{staticClass:"logo"},[_c('ThreeflowWordmark')],1),(_vm.title)?_c('h2',{domProps:{"textContent":_vm._s(_vm.title)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }